module.exports = __webpack_public_path__ + "static/media/SVG_telephone.7c55849e.svg";